export enum DisciplineEnum {
  BEACH_TENNIS = 'BEACH_TENNIS',
  PADEL = 'PADEL',
  PICKLEBALL = 'PICKLEBALL',
  TENNIS = 'TENNIS',
  WHEELCHAIR_TENNIS = 'WHEELCHAIR_TENNIS',
  BADMINTON='BADMINTON',
  TABLE_TENNIS='TABLE_TENNIS',
  SQUASH='SQUASH'

}
